import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  // Check if the screen size is mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };
  const fname = localStorage.getItem("firstname");
  const lname = localStorage.getItem("lastname");
  const token = localStorage.getItem("admin_token");
  const username = `${fname} ${lname}`;

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("user_token");
    localStorage.removeItem("user_id");
    navigate("/");
  };

  return (
    <div>
      <div
        style={{
          backgroundImage:
            "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)",
        }}
      >
        <div className="top-info-bar">
          <div className="">
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="row text-center">
                  <div className="item fw-600 col-sm-12 col-md-6">
                    Phone: +255 757 900007
                  </div>
                  <div className="item fw-600 col-sm-12 col-md-6">
                    Email: office@premiumcarrentals.co.tz
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <header className="site-navbar site-navbar-target mt-5" role="banner">
          <div className="container">
            <div className="row align-items-center position-relative">
              <div className="col-3">
                <div className="site-logo">
                  <Link to="/">
                    <img
                      style={{ width: 170 }}
                      src="https://i.ibb.co/mGh4f8g/Premium-Car-Rentals-Limited-Logo-Design-1-removebg-preview.png"
                      alt="Premium Car Rentals"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-9 text-right">
                {isMobile && (
                  <span className="d-inline-block togleekrishns">
                    <button
                      onClick={toggleMenu}
                      className="text-white site-menu-toggle py-5"
                    >
                      <span className="icon-menu h3 text-white"></span>
                    </button>
                  </span>
                )}
                <nav
                  className={`site-navigation ${
                    menuOpen || !isMobile ? "menu-open" : ""
                  } text-right ml-auto`}
                  role="navigation"
                >
                  <ul className="site-menu main-menu js-clone-nav ml-auto">
                    <li className="active">
                      <Link to="/" className="nav-link" onClick={closeMenu}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/about"
                        className="nav-link"
                        onClick={closeMenu}
                      >
                        About
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/ourFleet"
                        className="nav-link"
                        onClick={closeMenu}
                      >
                        Our Fleet
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/ourServices"
                        className="nav-link"
                        onClick={closeMenu}
                      >
                        Our Services
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact"
                        className="nav-link"
                        onClick={closeMenu}
                      >
                        Contact
                      </Link>
                    </li>
                    <button
                      className="btn p-0 m-0"
                      style={{ backgroundColor: "#FDC800", color: "black" }}
                    >
                      {token && username ? (
                        <div className="dropdown">
                          <button
                            className="btn dropdown-toggle"
                            style={{
                              backgroundColor: "#FDC800",
                              color: "black",
                            }}
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {username}
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={handleLogout}
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  textAlign: "center",
                                  margin: 0,
                                }}
                              >
                                Logout
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <Link
                          to="/login"
                          className="nav-link"
                          onClick={closeMenu}
                          style={{ textDecoration: "none", color: "black" }}
                        >
                          Login
                        </Link>
                      )}
                    </button>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default Navbar;
